import { GrowthChart } from '../LineChart';

export const Graph = ({ data }) => {
  const { data: result } = data;
  if (!result) return null;

  return (
    <div style={{ gridArea: 'graph' }}>
      <GrowthChart data={result} />
    </div>
  );
};
